import Detail from '../../../../components/Detail';
import InfoPopUp from '../../../../components/InfoPopUp';
import { formatUSD } from '../../../../helpers/formats';
import useTotalPerformanceFeesToDate from '../../../../hooks/web3/vault/useTotalPerformanceFeesToDate';

const CommunityPerformanceFeesToDate = () => {
    const { totalPerformanceFeesToDate } = useTotalPerformanceFeesToDate();

    return (
        <Detail
            title={
                <>
                    <span>Performance fees to date</span>
                    <InfoPopUp>
                        <div>
                            $SPOOL token stakers receive Emissions Rewards as well as the
                            DAO's Performance Fee of the total yield generated on
                            the Spool protocol as $SPOOL/$DAI LP tokens after a user
                            withdraws and realizes profits.
                        </div>
                    </InfoPopUp>
                </>
            }
            value={<>~${formatUSD(totalPerformanceFeesToDate || '0')}</>}
        />
    );
};

export default CommunityPerformanceFeesToDate;
